import PicnicVue from 'vue'
import App from './App.vue'
import store from './store'
import createAppEl from './lib/create-app-el'
import { ENV_IS_PRODUCTION } from './lib/env'
import SvgIcon from 'vue-svgicon'

// Core CSS
import './assets/css/ui.css'

// Plugins
import { DetachMixin } from './plugins/detach'
import { ToasterMixin } from './plugins/toaster'
import { ObjMixin } from './plugins/obj'
import SafeObject from './plugins/filter.safeObject'
import Capitalize from './plugins/filter.capitalize'
import { CloneDeepMixin } from './plugins/cloneDeep'

const APP_ID = 'picnic_team_app'

// Create element to append app
const siteId = createAppEl(APP_ID)

// // Setup plugins
PicnicVue.use(ToasterMixin)
PicnicVue.use(DetachMixin)
PicnicVue.use(ObjMixin)
PicnicVue.use(SafeObject)
PicnicVue.use(Capitalize)
PicnicVue.use(CloneDeepMixin)
PicnicVue.use(SvgIcon, {
  tagName: 'svg-icon',
  classPrefix: 'ps-svg',
  isStroke: true
})

PicnicVue.config.devtools = true
PicnicVue.config.debug = true
PicnicVue.config.silent = false
PicnicVue.config.productionTip = false

// Turn off debug and devtools in production build
if (ENV_IS_PRODUCTION) {
  PicnicVue.config.devtools = false
  PicnicVue.config.debug = false
  PicnicVue.config.silent = true
}

// Spin up app
const picnicVue = new PicnicVue({
  store,
  render: h => h(App, { props: { site: siteId } })
}).$mount(`#${APP_ID}`)
